import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Scroller } from 'primeng/scroller';

interface LazyEvent {
  first: number;
  last: number;
}

@Component({
  selector: 'ness-triage-history',
  templateUrl: './triage-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TriageHistoryComponent implements OnInit {
  @Input() triageHistoryTitle: string = 'Triage History';

  private _triageItems: ServerModels.CrimeGunTriageViewModel[] = [];
  triageItemsDisplaying: ServerModels.CrimeGunTriageViewModel[] = [];

  get triageItems(): ServerModels.CrimeGunTriageViewModel[] {
    return this._triageItems;
  }

  @Input() set triageItems(items: ServerModels.CrimeGunTriageViewModel[]) {
    this._triageItems = [...items];
    this.triageItemsDisplaying = this.triageItems;
  }

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this._setUserMessage();
  }

  private _setUserMessage() {
    if (!!this.triageItems.length) {
      this.triageItemsDisplaying = this.triageItems;
      //this.cdr.detectChanges();
    } else {
      let emptyData = {
        CrimeGunTriageID: null,
        CrimeGunID: null,
        TriageTierLevelID: null,
        CreatedOn: null,
        Comment: 'No triage history found.'
      } as ServerModels.CrimeGunTriageViewModel;

      this.triageItemsDisplaying.push(emptyData);
    }
  }
}
